import { useTranslation } from 'react-i18next';
import { FieldHelpTooltip } from '@/Domain/components/Integration/components/FieldHelpTooltip';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/Domain/components/Shared/Form/Form';
import { Input } from '@/Domain/components/Shared/Input/Input';
import { AutosizeTextarea } from '@/Domain/components/Shared/Textarea/Textarea';
import { useMcpForm } from '@/Domain/hooks/Action/useMcpForm/useMcpForm';

export const McpForm = () => {
  const { t } = useTranslation('mcp_page');
  const { form } = useMcpForm();

  return (
    <Form {...form}>
      <div className="flex flex-col gap-6">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <div className="flex items-center gap-1.5">
                <FormLabel>{t('form.name_label')}</FormLabel>
                <FieldHelpTooltip content={t('form.name_sublabel')} data-testid="mcp-name-help" />
              </div>
              <FormControl>
                <Input placeholder={t('form.name_placeholder')} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <div className="flex items-center gap-1.5">
                <FormLabel>{t('form.description_label')}</FormLabel>
                <FieldHelpTooltip
                  content={t('form.description_sublabel')}
                  data-testid="mcp-description-help"
                />
              </div>
              <FormControl>
                <AutosizeTextarea
                  placeholder={t('form.description_placeholder')}
                  {...field}
                  minHeight={112}
                  className="px-4"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="command"
          render={({ field }) => (
            <FormItem>
              <div className="flex items-center gap-1.5">
                <FormLabel>{t('form.command_label')}</FormLabel>
                <FieldHelpTooltip
                  content={t('form.command_sublabel')}
                  data-testid="mcp-command-help"
                />
              </div>
              <FormControl>
                <Input placeholder={t('form.command_placeholder')} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </Form>
  );
};
